'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _disclosure = require('./disclosure.js');

var _disclosure2 = _interopRequireDefault(_disclosure);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var PortfolioHoldingsChildCard = function (_React$Component) {
  _inherits(PortfolioHoldingsChildCard, _React$Component);

  function PortfolioHoldingsChildCard(props) {
    _classCallCheck(this, PortfolioHoldingsChildCard);

    return _possibleConstructorReturn(this, (PortfolioHoldingsChildCard.__proto__ || Object.getPrototypeOf(PortfolioHoldingsChildCard)).call(this, props));
  }

  _createClass(PortfolioHoldingsChildCard, [{
    key: 'renderValue',
    value: function renderValue(data) {
      if (!(0, _ramda.isNil)(data.displayValue)) {
        var dataPointSuffix = _constants2.default.getDataPointSuffix()[data.dataType];
        return data.displayValue + _string_utility2.default.getLocalizedString(this.props.intl, dataPointSuffix.value, dataPointSuffix.translationKey);
      }
      return '';
    }
  }, {
    key: 'generateTableRow',
    value: function generateTableRow(data) {
      var tableData = [];
      tableData.push(_react2.default.createElement('td', { key: data.name, className: 'text-left', 'data-testid': 'portfolio-child-name', dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(data.name) } }));
      tableData.push(_react2.default.createElement('td', { key: data.name + '-1', className: 'text-right', 'data-testid': 'portfolio-child-value', dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.renderValue(data)) } }));
      tableData.push(_react2.default.createElement(
        'td',
        { className: "width-percent-40" },
        '\xA0'
      ));
      return tableData;
    }
  }, {
    key: 'generateTableRows',
    value: function generateTableRows() {
      var _this2 = this;

      var tableRows = [];
      {
        mapIndexed(function (data, index) {
          var tableData = _this2.generateTableRow(data);
          var tableRow = _react2.default.createElement(
            'tr',
            { key: index, 'data-testid': 'portfolio-child-row', className: 'category portfolio-override-bold row-divider' },
            tableData
          );
          tableRows.push(tableRow);
        }, this.props.data);
      }
      return tableRows;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.data.length === 0) {
        return null;
      }
      var ariaLabel = "";
      if (!(0, _ramda.isNil)(this.props.header)) {
        var title = (0, _functional_utility.isNilOrEmpty)(this.props.header.key) ? this.props.header : _string_utility2.default.getLocalizedString(this.props.intl, this.props.header.props.defaultMessage, this.props.header.key);
        ariaLabel = 'Read more about ' + title;
      }
      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card' },
        _react2.default.createElement(_reactWaypoint2.default, { topOffset: '35%', bottomOffset: '80%', onEnter: this.props.activeCardHandler.bind(this, this.props.id) }),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.props.header,
            headerTitleId: this.props.id,
            headerTitleLabel: "portfolio-child-header",
            breakpoint: this.props.breakpoint,
            headerLabel: _date_formatter2.default.getEffectiveDateHeader(this.props.id, this.props.effectiveDate, this.props.country, this.props.role, this.props.breakpoint)
          },
          _react2.default.createElement(_table_component2.default, {
            tableRows: this.generateTableRows(),
            activeTab: this.props.activeTab,
            breakpoint: this.props.breakpoint
          }),
          _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosureText, placementId: this.props.placementId, arialabel: ariaLabel })
        )
      );
    }
  }]);

  return PortfolioHoldingsChildCard;
}(_react2.default.Component);

exports.default = PortfolioHoldingsChildCard;